<template>
    <div>
        <div v-if="passed_filter">
            <div class="designeroption" data-designer-component-id="measurements">
                <h3>Measurements</h3>
                <div class="stylesoption">
                    <div :class="['form-group', !valid_door ? 'has-error' : '']">
                        <label :class="[!valid_door ? 'text-danger' : '']">Door Width x Height</label>
                        <span :class="[!valid_door_width ? 'text-danger' : '']">{{ door_width }}mm</span> x <span :class="[!valid_door_height ? 'text-danger' : '']">{{ door_height }}mm</span>
                    </div>
                    <div v-for="measurement in measurements"
                         :class="['form-group mt-6', target[measurement.slug] === undefined || target[measurement.slug] > limits[measurement.slug].max || target[measurement.slug] < limits[measurement.slug].min ? 'has-error' : 'has-success']">
                        <label :for="component_id + '_' + measurement.slug">{{ measurement.title }}
                            <template v-if="loading">(Checking Min/Max...)</template>
                            <template v-if="!loading">({{ limits[measurement.slug].min }}mm to {{ limits[measurement.slug].max }}mm)</template>
                        </label>
                        <input :dusk="measurement.slug" :id="component_id + '_' + measurement.slug" type="number" v-model="target[measurement.slug]" class="form-control"
                               :placeholder="measurement.title" min="{{ limits[measurement.slug].min }}" max="{{ limits[measurement.slug].max }}" pattern="[0-9]" @keydown="filterKey" @input="filterInput">
                        <em v-if="show_message(measurement.slug, this.frameId)" class="txt-light txt-sm pt-1">
                            {{ show_message(measurement.slug, this.frameId) }}
                        </em>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
    import DesignerQuestionMeasurements from "../DesignerQuestionMeasurements.vue";

    export default {
        mixins: [
            DesignerQuestionMeasurements
        ],
        props: {
            separate_toplights: {
                default() {
                    return [8, 5, 11, 3];
                }
            },
            couplers: {
                required: true,
            },
        },
        computed: {
            cache_key(){
                return '_' + this.fabricator
                    + '_' + this.slab
                    + '_' + this.externalColour
                    + '_' + this.internalColour
                    + '_' + this.frameProfile
                    + '_' + this.threshold
                    + '_' + this.hardwareLock
                    + '_' + this.hardwareHinge
                    + '_' + this.hardwareHandle
                    + '_' + this.hardwareKnocker
                    + '_' + this.hardwareSpyHole
                    + '_' + this.hardwareEscutcheon
                    + '_' + this.hardwareLetterbox
                    + '_' + this.hardwareLetterboxPosition
                    + '_' + this.frameId
                    + '_' + JSON.stringify(this.addons)
                    + '_' + JSON.stringify(this.couplers)
                    + '_' + this.cill
                    + '_' + JSON.stringify(this.filteredSidePanels)
                    + '_' + this.doorRange;
            },
            url(){
                return '/api/options/' + this.fabricator + '/measurements?slab=' + this.slab
                    + '&external_colour=' + this.externalColour
                    + '&door_colour_internal=' + this.internalColour
                    + '&profile=' + this.frameProfile
                    + '&threshold=' + this.threshold
                    + '&hardware_lock=' + this.hardwareLock
                    + '&hardware_hinge=' + this.hardwareHinge
                    + '&hardware_handle=' + this.hardwareHandle
                    + '&hardware_knocker=' + this.hardwareKnocker
                    + '&hardware_spy_hole=' + this.hardwareSpyHole
                    + '&hardware_escutcheon=' + this.hardwareEscutcheon
                    + '&hardware_letterbox=' + this.hardwareLetterbox
                    + '&hardware_letterbox_position=' + this.hardwareLetterboxPosition
                    + '&frame_style=' + this.frameId
                    + '&addons=' + encodeURIComponent(JSON.stringify(this.addons))
                    + '&couplers=' + encodeURIComponent(JSON.stringify(this.couplers))
                    + '&cill=' + this.cill
                    + '&side_panels=' + encodeURIComponent(JSON.stringify(this.filteredSidePanels))
                    + '&door_range=' + this.doorRange;
            },
            filteredSidePanels(){

                let side_panels = JSON.parse(JSON.stringify(this.sidePanels));

                let valid_properties = {};

                valid_properties.left = side_panels.left;
                valid_properties.right = side_panels.right;
                valid_properties.left_composite_id = side_panels.left_composite_id;
                valid_properties.right_composite_id = side_panels.right_composite_id;

                return valid_properties;
            },
        },
        methods: {
            show_message(slug, frame) {
                //return ''; // disable messages
                if (slug === 'top_box_drop') {
                    if (this.separate_toplights.includes(frame)) {
                        return 'Size including a 16mm coupler and any additional add ons';
                    }
                    return 'Size including any additional add ons';
                }
                else if (slug === 'right_width' || slug === 'left_width') {
                    return 'Size including any additional add ons';
                }
                else if (slug === 'flag_height') {
                    if (!this.separate_toplights.includes(frame)) {
                        return 'Size including any additional cills and addons';
                    }
                    return 'Size including any additional cills';
                }
                else if (slug === 'overall_width') {
                    return 'Size including any additional add ons';
                }
                else if (slug === 'overall_height') {
                    return 'Size including any additional cills and add ons';
                }
                return false;
            },
        },
        watch: {
            'frameId': function (val, oldVal) {
                this.update_options();
            },
            'slab': function (val, oldVal) {
                this.update_options();
            },
            'externalColour': function (val, oldVal) {
                this.update_options();
            },
            'internalColour': function (val, oldVal) {
                this.update_options();
            },
            'frameProfile': function (val, oldVal) {
                this.update_options();
            },
            'threshold': function (val, oldVal) {
                this.update_options();
            },
            'addons': {
                handler: function (val, oldVal) {
                    this.update_options();
                },
                deep: true,
            },
            'couplers': {
                handler: function (val, oldVal) {
                    this.update_options();
                },
                deep: true,
            },
            'cill': function (val, oldVal) {
                this.update_options();
            },
            'hardwareLock': function (val, oldVal) {
                this.update_options();
            },
            'hardwareHinge': function (val, oldVal) {
                this.update_options();
            },
            'hardwareHandle': function (val, oldVal) {
                this.update_options();
            },
            'hardwareKnocker': function (val, oldVal) {
                this.update_options();
            },
            'hardwareSpyHole': function (val, oldVal) {
                this.update_options();
            },
            'hardwareEscutcheon': function (val, oldVal) {
                this.update_options();
            },
            'hardwareLetterbox': function (val, oldVal) {
                this.update_options();
            },
            'hardwareLetterboxPosition': function (val, oldVal) {
                this.update_options();
            },
            'doorRange': function (val, oldVal) {
                this.update_options();
            },
            'sidePanels': {
                handler: function (val, oldVal) {
                    this.update_options();
                },
                deep: true,
            },
            'limits': {
                handler: function (val, oldVal) {
                    if (val !== []){
                        window.emitter.emit('limits-updated', { limits: val })
                    }
                    this.update_options();
                },
                deep: true,
            }
        }
    }
</script>
